import "./profilepage.scss";
import { Fragment, h } from "preact";
import { RouterProps } from "preact-router";
import { Button, Container, FormField, Spacer } from "uitoolkit";
import { useBodyStyle, useEditor, usePageTitle } from "hooks";
import { globalUserState, logout, logoutAllDevices } from "state";
import { useMemo } from "preact/hooks";
import { type UserProfile, updateUser } from "services/backend";
import { useUsage } from "services/backend/usage";
import { UsageTotalsCards } from "../usage/usagepage";
import { type Persona, usePersonas } from "services/backend/personas";
import { uiToast } from "services/uiservice";
import { Sidebar } from "components/sidebar";

// tslint:disable: typedef
//const personas = [{ id: "foo", name: "Default" }, { id: "bar", name: "Friendly" }] as const;

export function ProfilePage(props: {} & RouterProps) {
    const user = globalUserState.value.user;
    //const [isLoading, setIsLoading] = useState(false);
    useBodyStyle("profilepage");
    usePageTitle("Profile");

    //console.log("render")

    const personasQuery = usePersonas();
    const personas = personasQuery.result?.chat.personas ?? null;

    return (
        <Fragment>
            <Container class="row grow maxheight-100vh overflow-y-hidden">
                <Sidebar page="profile" />
                <Container class="flex-column overflow-y-auto grow">
                    <div style={{ paddingTop: "16px" }} />
                    <Container class="p-4 pt-0 bg-primary gap-16 flex-column grow maxwidth">
                        <UsageCard />
                        <hr />
                        <UserCard user={user!} personas={personas} />
                        <hr />
                        <SessionCard />
                    </Container>
                </Container>
            </Container>
        </Fragment>
    );
}

function UserCard({ user, personas }: { user: UserProfile, personas: Persona[] | null }) {

    const initial = useMemo(() => ({ name: user.name, email: user.email, password: "", llmPersonaId: user.llmPersona?.id ?? "", llmInstructions: user.llmInstructions }), []);
    const { data, handleInputChange } = useEditor<{ name?: string, email?: string, password?: string, llmPersonaId?: string, llmInstructions?: string }>(initial);

    async function save() {
        const ok = await updateUser(data);
        if (ok) {
            uiToast("User profile saved");
            //
        } else {
            //
        }
    }

    //console.log(data);
    const persona = personas?.find(n => n.id == data.llmPersonaId);

    return (
        <Fragment>
            <h2>Profile</h2>
            <Container class="component-form wide-form">
                <FormField id="input_name" name="name" type="text" value={data.name} label="Full name" onChange={handleInputChange} />
                <FormField id="input_email" name="email" type="email" value={data.email} label="Email" onChange={handleInputChange} />
                <FormField id="input_password" name="password" type="password" value={data.password} label="New password" autoComplete="new-password" onChange={handleInputChange} />
            </Container>
            <h2>Customization</h2>
            <Container class="component-form wide-form">
                <FormField id="input_llmpersonaid" name="llmPersonaId" type="select" permittedValuesList={personas as any} value={data.llmPersonaId} label="LLM persona" onChange={handleInputChange} />
                {
                    persona && <div class="formfield" style={{ marginBottom: "16px" }}>
                        <div>{persona.description}</div>
                        <label />
                    </div>
                }
                <FormField id="input_llminstructions" name="llmInstructions" type="textarea" value={data.llmInstructions} label="Custom instructions" onChange={handleInputChange} />
            </Container>
            <Container class="flex-row">
                <Spacer />
                <Button variant="primary" onClick={save}>Save</Button>
            </Container>
        </Fragment>
    );
}

function UsageCard() {
    const usageResult = useUsage();

    return (
        <Container>
            <h2>Usage</h2>
            <UsageTotalsCards usageResult={usageResult?.result} />
        </Container>
    );
}


function SessionCard() {
    return (
        <Container>
            <h2>Session</h2>
            <br />
            <Container class="flex-row gap-16">
                <Spacer />
                <Button onClick={logoutAllDevices}>Log out all devices</Button>
                <Button onClick={logout}>Log out</Button>
            </Container>
        </Container>
    );
}